module.exports = __webpack_public_path__ + "./img/info.eb80e4af767172331af2acc1ce8427ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/info.png
// module id = ./assets/images/info.png
// module chunks = 0